import dispatcher from '../dispatcher';
import popupStore from '../popup/popup.store';

// class close-all для кнопок, которые закрывают все попапы.
// сам проставляет aria аттрибуты

var elementProto = Object.create(HTMLButtonElement.prototype);

var _handleStore = function() {
	var active = popupStore.getData().active;
	if (this.classList.contains('close-all')) {
		if (active) {
			this.setAttribute('aria-expanded', 'true');
			this.classList.add('active');
		} else {
			this.setAttribute('aria-expanded', 'false');
			this.classList.remove('active');
		}
	} else {
		if (active === this._id) {
			this.setAttribute('aria-expanded', 'true');
			this.classList.add('active');
		} else {
			this.setAttribute('aria-expanded', 'false');
			this.classList.remove('active');
		}
	}
}

var _handleClick = function() {
	var active = popupStore.getData().active;
	var element;
	var target = this.getAttribute('data-target');

	if (target) {
		element = this.querySelector(target);
	} else {
		element = this;
	}

	if (this.classList.contains('close-all') && active) {
		dispatcher.dispatch({
			type: 'popup:close',
			element: element
		});
	} else {
		dispatcher.dispatch({
			type: 'popup:toggle',
			id: this._id,
			element: element
		});
	}
}

var _handleMouseenter = function() {
	var parent = this.closest('.link-group');
	var elements;
	if (this.classList.contains('active') || !parent) return;

	elements = parent.querySelectorAll('button[is="popup-toggle"]');
	Array.prototype.forEach.call(elements, function(el) {
		el.classList.add('hover');
	});
}

var _handleMouseleave = function() {
	var parent = this.closest('.link-group');
	var elements;
	if (!parent) return;

	elements = parent.querySelectorAll('button[is="popup-toggle"]');
	Array.prototype.forEach.call(elements, function(el) {
		el.classList.remove('hover');
	});
}

elementProto.createdCallback = function() {
	this.handleClick = _handleClick.bind(this);
	this.handleStore = _handleStore.bind(this);
	this.handleMouseenter = _handleMouseenter.bind(this);
	this.handleMouseleave = _handleMouseleave.bind(this);
}
elementProto.attachedCallback = function() {
	this._id = this.getAttribute('data-id');
	this.setAttribute('aria-haspopup', 'true');

	this.addEventListener('click', this.handleClick);
	this.addEventListener('mouseenter', this.handleMouseenter);
	this.addEventListener('mouseleave', this.handleMouseleave);

	popupStore.subscribe(this.handleStore);
	this.handleStore();
}
elementProto.detachedCallback = function() {
	this.removeEventListener('click', this.handleClick);
	popupStore.unsubscribe(this.handleStore);
}

document.registerElement('popup-toggle', {
	extends: 'button',
	prototype: elementProto
});

export default elementProto;